<template>
    <div>
        <v-card>
        <v-card-text>
            <v-row justify="center">
                <v-col>
                    <!-- parte frontal del carnet -->
                     <!-- delantero -->
                    <div class="delantero">
                        <img :src="item.url_foto" alt="" class="perfil">
                        <div class="datos">
                            <h6 class="nombre">{{ item.nombres }} {{ item.apellidos }}</h6>
                            <p class="cargo">{{ item.cargo }}</p>
                            <p class="unidad">{{ item.area }}</p>
                        </div>
                        <div class="alcaldia">
                            <img :src="logoFrente" alt="logo" class="logo">
                            <h6>Alcald&iacute;a de <br> San Salvador Sur</h6>
                        </div>
                    </div>
                </v-col>
                <v-col>
                    <!-- cara trasera -->
                    <!-- trasero -->
                    <div class="trasero">
                        <img :src="logoTrasero" alt="logo" class="logo-tr">
                        <img :src="item.url_qr" alt="" class="qr">
                        <h6 class="dui">DUI: {{ item.dui }}</h6>
                    </div>
                </v-col>
            </v-row> 
        </v-card-text>
        <v-divider></v-divider>
        <v-btn style="padding: 5px 10px 5px 10px; margin: 5px;" color="success" @click="generarPdf(item.id+item.llave)">Imprimir</v-btn>
    </v-card>
</div>
   
</template>
<script>
export default {
    name:"carnetCv2",
    props: {
      item: {
        type: Object,
        required: true,
        default: () => ({
          url_foto: "",
          nombres: "Nombre del usuario",
          cargo: "Cargo del usuario",
          distrito: "Distrito asignado",
          url_qr: "",
        }),
      },
      logoFrente: {
        type: String,
        default: "",
      },
      logoTrasero: {
        type: String,
        default: "",
      },
    },
    data(){
        return{
            config:{
                headers:{'Authorization':'Bearer '+this.$store.getters.getToken}
            },
        }
    },
    methods: {
        generarPdf(id){
            window.open(`${this.$store.state.dominio}/generarcarnetrv2/${id}`,'_blank');
        },
    },
}
</script>
<style scoped>
@font-face {
    font-family: 'fuente-carnet';
    src: url('../assets/BAHNSCHRIFT.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}
 .v-divider {
    margin: 10px 0;
}


.delantero, .trasero{
    font-family: 'fuente-carnet';
    position: relative;
    flex-direction: column;
    align-items: center;
    display: flex;
    gap: 0.5mm;
    width: 56mm;
    height: 86.5mm;
    max-width: 56mm;
    max-height: 86.5mm;
    min-width: 56mm;
    min-height: 86.7mm;
    background-color: #001BA0;
    padding: 3mm;
    color: white;
    border-radius: 20px;
    box-shadow: 1px 1px 10px grey;
    margin: 0 auto;
}

.perfil{
    margin-top: 5mm;
    width: 35mm;
    height: 35mm;
    border-radius: 50%;
    border: 7px solid #CAFBFF;
    object-fit: cover;
}

.datos{
    margin-top: 0.8mm;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 20mm;
    text-align: center;
}

.nombre{
    font-size: 16pt;
}

.cargo{
    text-align: center;
    font-size: 9pt;
}

.unidad{
    margin-top: 1mm;
    width: 90%;
    border: 1px solid #CAFBFF;
    border-radius: 5px;
    padding: 3px;
    font-size: 7pt;
}
.alcaldia{
    position: absolute;
    bottom: 3mm;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo{
    width: 16mm;
    height: 16mm;
    border-radius: 50%;
    object-fit: cover;
}
.alcaldia h6{
    margin-top: -10px;
    width: 20mm;
    text-align: center;
    font-size: 6pt;
}
/* trasero */
.trasero{
    justify-content: center;
}
.logo-tr{
    width: 30mm;
    height: 30mm;
    border-radius: 50%;
    object-fit: cover;
}

.qr{
    width: 35mm;
    height: 35mm;
}

    
</style>